import script from "./UserInfoExtended.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoExtended.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoExtended.vue?vue&type=style&index=0&id=09a11999&lang=scss"

const __exports__ = script;

export default __exports__